import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MarketingShell, CONTACT_EMAIL, IMG } from './LandingPage';

const SupportPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MarketingShell
      title="Support - NAC Easy Solution"
      description="Contact Us and portal login for NAC Easy Solution."
    >
      <section className="sk-page-hero" style={{ backgroundImage: `url(${IMG.gst})` }}>
        <div>
          <h1>Support</h1>
          <p>Their customer service is responsive and helpful, ensuring our business runs smoothly at all times.</p>
        </div>
      </section>

      <section className="sk-section">
        <div className="sk-grid-3">
          <article className="sk-card">
            <div className="sk-card-img" style={{ backgroundImage: `url(${IMG.quote3})` }} />
            <h3>Contact Us</h3>
            <p>Send your shop details and we will help you get started.</p>
            <a className="sk-btn" href={`mailto:${CONTACT_EMAIL}`}>Contact Us</a>
          </article>
          <article className="sk-card">
            <div className="sk-card-img" style={{ backgroundImage: `url(${IMG.pos})` }} />
            <h3>Staff login</h3>
            <p>Cashiers and store staff sign in on the till.</p>
            <button type="button" className="sk-btn" onClick={() => navigate('/user/login')}>Staff login</button>
          </article>
          <article className="sk-card">
            <div className="sk-card-img" style={{ backgroundImage: `url(${IMG.ops})` }} />
            <h3>Admin login</h3>
            <p>Shop owners and managers sign in for stock, orders, and reports.</p>
            <button type="button" className="sk-btn" onClick={() => navigate('/admin/login')}>Admin login</button>
          </article>
        </div>
      </section>
    </MarketingShell>
  );
};

export default SupportPage;
